import { render, staticRenderFns } from "./ApplicationAuthorize.vue?vue&type=template&id=0d2ff90a&"
import script from "./ApplicationAuthorize.vue?vue&type=script&lang=js&"
export * from "./ApplicationAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationAuthorize.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports